"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _constants = require("./constants");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TRUMP_WEIGHT = 10;

var GameCard = /*#__PURE__*/function () {
  function GameCard(_ref) {
    var suit = _ref.suit,
        rank = _ref.rank;

    _classCallCheck(this, GameCard);

    _defineProperty(this, "id", null);

    _defineProperty(this, "suit", null);

    _defineProperty(this, "rank", null);

    _defineProperty(this, "weight", null);

    _defineProperty(this, "label", null);

    _defineProperty(this, "trump", false);

    this.id = "card-".concat(suit, "-").concat(rank);
    this.suit = suit;
    this.rank = rank;
    this.weight = rank;
    this.label = _constants.CARD_LABELS[rank];
  }

  _createClass(GameCard, [{
    key: "setTrump",
    value: function setTrump(value) {
      this.trump = value;

      if (this.trump) {
        this.weight += TRUMP_WEIGHT;
      }
    }
  }, {
    key: "isTrump",
    get: function get() {
      return this.trump;
    }
  }]);

  return GameCard;
}();

exports["default"] = GameCard;